module.exports = __webpack_public_path__ + "img/idg_btn_bg.4b873d3.webp";